// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBankOutlinedSvg from "@fishx/icons-svg/es/asn/PBankOutlined";
import FishxIcon from '../components/FishxIcon';

var PBankOutlined = function PBankOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBankOutlinedSvg
  }));
};

PBankOutlined.displayName = 'PBankOutlined';
export default React.forwardRef(PBankOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBankOutlined.js
// module id = 3227
// module chunks = 0